export function isFullSentence(text: string): boolean {
  return text.endsWith(".") || text.endsWith("?") || text.endsWith("!");
}

/**
 * Returns the most recent sentence in `text` (the part after the last sentence
 * boundary), so a streaming caption refreshes one sentence at a time. A boundary
 * is a terminator followed by whitespace or an uppercase letter (the model
 * sometimes drops the space, e.g. "word2.Word1"); a following digit is ignored
 * so decimals like "3.5" don't split.
 */
export function currentSentence(text: string): string {
  const trimmedEnd = text.replace(/\s+$/, "");
  let lastBoundary = -1;
  for (let i = 0; i < trimmedEnd.length - 1; i++) {
    const char = trimmedEnd[i];
    const isTerminator = char === "." || char === "?" || char === "!";
    const next = trimmedEnd[i + 1];
    if (isTerminator && (/\s/.test(next) || /[A-Z]/.test(next))) {
      lastBoundary = i;
    }
  }
  return lastBoundary === -1 ? text.trimStart() : trimmedEnd.slice(lastBoundary + 1).trimStart();
}

export function toSnakeCase(str: string): string {
  return str
    .replace(/([a-z])([A-Z])/g, "$1_$2")
    .replace(/([A-Z])([A-Z][a-z])/g, "$1_$2")
    .toLowerCase();
}
